import api from '../../store/config/api';
import { MESSAGE as SCHEMA } from '../../schemas';

export const [
  ADD_MESSAGE,
  ADD_MESSAGE_REQUEST,
  ADD_MESSAGE_SUCCESS,
  ADD_MESSAGE_FAILURE
] = api.buildTypes('ADD_MESSAGE');

// If you want to add a comment to a run, use comment.addComment instead.
export function addMessage({ teamName, threadID, username, body }) {
  return {
    type: ADD_MESSAGE,
    payload: {
      url: `/teams/${teamName}/threads/${threadID}/messages`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: { username, body }
      }
    }
  };
}

export const [
  GET_MESSAGE_BODY,
  GET_MESSAGE_BODY_REQUEST,
  GET_MESSAGE_BODY_SUCCESS,
  GET_MESSAGE_BODY_FAILURE
] = api.buildTypes('GET_MESSAGE_BODY');

export function getMessageBody({ teamName, threadID, messageID }) {
  return {
    type: GET_MESSAGE_BODY,
    payload: {
      url: `/teams/${teamName}/threads/${threadID}/messages/${messageID}/body`,
      options: {
        method: 'GET'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/message.js